(() => {
  'use strict';
  if (!window.customElements || customElements.get('melani-product-preview')) return;
  class MelaniProductPreview extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      const stage = this.querySelector('[data-mpv-zoom]');
      const mainImage = this.querySelector('.mpv-main-image');
      const dialog = this.querySelector('.mpv-lightbox');
      const largeImage = this.querySelector('[data-mpv-large-image]');
      const closeButton = this.querySelector('[data-mpv-close]');
      const thumbs = Array.from(this.querySelectorAll('[data-mpv-thumb]'));
      for (const thumb of thumbs) {
        thumb.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !stage || !mainImage) return;
          event.preventDefault();
          mainImage.removeAttribute('srcset');
          mainImage.src = thumb.dataset.imageSrc;
          mainImage.alt = thumb.dataset.imageAlt || '';
          stage.href = thumb.href;
          for (const item of thumbs) item.removeAttribute('aria-current');
          thumb.setAttribute('aria-current', 'true');
        });
      }
      if (!stage || !dialog || !largeImage || typeof dialog.showModal !== 'function') return;
      stage.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        largeImage.src = stage.href;
        largeImage.alt = mainImage ? mainImage.alt : 'Product image';
        if (!dialog.open) dialog.showModal();
      });
      if (closeButton) closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => { stage.focus({ preventScroll: true }); });
    }
  }
  customElements.define('melani-product-preview', MelaniProductPreview);
})();
